import { Bar } from 'vue-chartjs/legacy';

// @vue/component
export default {
    name: 'SurveyChartsChart',
    components: {
        Bar
      },
      props: {
        chartId: {
          type: String,
          default: 'bar-chart'
        },
        datasetIdKey: {
          type: String,
          default: 'label'
        },
        width: {
          type: Number,
          default: 400
        },
        height: {
          type: Number,
          default: 300
        },
        cssClasses: {
          default: '',
          type: String
        },
        styles: {
          type: Object,
          default: () => {}
        },
        plugins: {
          type: Array,
          default: () => []
        },
        chartData: {
            type: Object,
            default: () => {}
        },
        question: {
            type: String,
            default: ''
        }
      },
      data() {
        return {
          chartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
              display: false,
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  callback: function(value) {if (value % 1 === 0) {return value;}}
                }
              }]
            }
          }
        }
      }
    }